import { render, staticRenderFns } from "./ImpactFairly.vue?vue&type=template&id=4d831874"
import script from "./ImpactFairly.vue?vue&type=script&lang=js"
export * from "./ImpactFairly.vue?vue&type=script&lang=js"
import style0 from "./ImpactFairly.vue?vue&type=style&index=0&id=4d831874&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports